import '@/assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import { initRouter } from './router'
import { initMetaPixel, trackMetaAdLandingOnce } from '@/utils/metaPixel'

const app = createApp(App)

const store = createPinia()
store.use(piniaPluginPersistedstate)
app.use(store)
initMetaPixel()
trackMetaAdLandingOnce()
initRouter(app)

app.mount('#app')
